export default class Sound extends EventTarget {
	constructor() {
		super();
		this.readyState = 'none';
	}

	_setReadyState(state, detail) {
		this.readyState = state;
		queueMicrotask(() => this.dispatchEvent(new CustomEvent(state, { detail })));
	}

	stop() {
		throw new Error('Unimplemented');
	}
}
